import { render } from "./CookiesAcceptComponent.vue?vue&type=template&id=fa148a62&scoped=true"
import script from "./CookiesAcceptComponent.vue?vue&type=script&lang=js"
export * from "./CookiesAcceptComponent.vue?vue&type=script&lang=js"

import "./CookiesAcceptComponent.vue?vue&type=style&index=0&id=fa148a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa148a62"]])

export default __exports__